import { Button, Modal, Result, Select } from "antd";
const { Option } = Select;

const ErrorResult = ({ show, title, subTitle, okText, onOkClick, onCancelClick = null, cancelText = null }) => {
    return (
        <Modal open={show} centered closable={false} maskClosable={false} destroyOnHidden={true} footer={null}>
            <Result
                status="error"
                title={title}
                subTitle={subTitle}
                extra={[
                    <Button type="primary" onClick={() => onOkClick && onOkClick()}>
                        {okText || "Ok"}
                    </Button>,
                    onCancelClick && <Button onClick={() => onCancelClick && onCancelClick()}>{cancelText || "Cancel"}</Button>,
                ]}
            />
        </Modal>
    );
};

export default ErrorResult;
